export const maskAccNumber = (input = '') =>
  input.replace(input.substring(0, 4), '****');

export const maskSortCode = (input = '') =>
  input.replace(input.substring(0, 5), '**-**');

export const maskIban = (input = '') =>
  input.length <= 6
    ? input
    : input.replace(input.substring(6), '*'.repeat(input.length - 6));
